import './../index.css';
import TreeCollection from './treeCollection.js';

/**
 * Рекурсивно проходит по списку моделей, применяет к каждой модели переданную функцию.
 */
const walk = (
/** Дерево для обработки. */
tree, 
/** Вызываемая функция. */
callback, 
/** Массив моделей родителей от ближнего к дальнему. */
parents) => {
    const currentParents = parents ? parents.slice() : [];
    tree.forEach((item) => {
        callback(item, currentParents);
        if (item.items && item.items.length) {
            walk(item.items, callback, [item].concat(currentParents));
        }
    });
};
/**
 * Возвращает коллекцию, созданную из дерева.
 * @param tree
 * @param [callback] Функция, вызываемая на каждом элементе.
 */
const fromTree = (tree, callback) => {
    const collection = new TreeCollection();
    walk(tree, (item, parents) => {
        if (typeof callback === 'function') {
            callback(item, parents);
        }
        collection.addModel(item, parents.length ? parents[0].id : undefined);
    });
    return collection;
};
/**
 * Возвращает только те ID, которые присутствуют в коллекции
 */
const filterMissingIds = (collection, ids) => {
    const filteredIds = [];
    ids.forEach((id) => {
        if (collection.getModel(id)) {
            filteredIds.push(id);
        }
    });
    return filteredIds;
};
/**
 * Возвращает ID только тех элементов, у которых нет потомков.
 */
const filterParents = (collection, ids) => {
    return ids.filter((id) => {
        return collection.getChildrenIds(id).length === 0;
    });
};
/**
 * Возвращает новую коллекцию, содержащую элементы, для которых `filterFunction` вернула true.
 * Если заматчился дочерний элемент, к результатам добавляются его родители до самого верха.
 * Если заматчился родитель, к результатам НЕ добавляются его дочерние элементы (кроме тех,
 * что тоже заматчились).
 */
const filterWithParents = (collection, filterFunction, isMobile) => {
    const filteredCollection = new collection.constructor();
    const ids = new Set();
    collection.walk((model, parents) => {
        if (filterFunction(model)) {
            ids.add(model.id);
            if (!isMobile) {
                parents.forEach((parent) => {
                    ids.add(parent.id);
                });
            }
        }
    });
    ids.forEach((id) => {
        const model = collection.getModel(id);
        if (model) {
            // В модели с дубликатами у элемента может быть несколько родителей
            const parentIds = collection.getParentIdsDuplicates(model.id);
            if (parentIds.length && !isMobile) {
                parentIds.forEach((parendId) => {
                    filteredCollection.addModel({ ...model }, parendId);
                });
            }
            else {
                filteredCollection.addModel({ ...model });
            }
        }
    });
    return filteredCollection;
};
/**
 * Возвращает новую коллекцию, содержащую уникальные элементы самого нижнего уровня,
 * для которых `filterFunction` вернула true (плоский список).
 */
const filterUniqueLeavesOnly = (collection, filterFunction) => {
    const filteredCollection = new TreeCollection();
    collection.walk((model) => {
        if (!filteredCollection.getModel(model.id) && !collection.hasChildren(model.id) && filterFunction(model)) {
            filteredCollection.addModel({ ...model });
        }
    });
    return filteredCollection;
};
/**
 * Возвращает элементы из списка, родители которых отсутствуют в этом же списке.
 * Полезно для определения минимального набора выбранных элементов (если выбран родитель
 * целиком, игнорируем его дочерние элементы)
 */
const getIdsWithNoParentsInSameList = (collection, ids) => {
    const hasChildrenHash = ids.reduce((result, id) => {
        result[id] = collection.getChildren(id).length > 0;
        return result;
    }, {});
    return ids.filter((id) => {
        const parentIds = collection.getParentIdsDuplicates(id);
        return !parentIds.some((id) => hasChildrenHash.hasOwnProperty(id) && hasChildrenHash[id]);
    });
};

export { filterMissingIds, filterParents, filterUniqueLeavesOnly, filterWithParents, fromTree, getIdsWithNoParentsInSameList, walk };
//# sourceMappingURL=treeCollectionHelper.js.map
